"use client";

import { emptyCartState } from "../../../../assets";
import Pagination from "../../../common/Pagination";
import BaseStorePage from "../shared/base-store-page";
import CategoryList from "./search-category";
import CoverPage from "./cover-page";
import FloatingHelper from "./floating-helper";
import styles from "./index.module.css";
import ProductItem from "./product/product-card";
import SkeletonCard from "./skeleton-card";
import StoreBox from "./store-box";

const renderDefaultEmptyState = ({ styles }) => (
  <div className={styles.emptystate}>
    <div className={styles.emptyStateArt}>{emptyCartState}</div>
    <div className={styles.emptyStateCopy}>
      <h3>No products available</h3>
      <p>This shelf is empty right now. Try another category or check back soon.</p>
    </div>
  </div>
);

function StorePage(props) {
  return (
    <BaseStorePage
      {...props}
      styles={styles}
      StoreBox={StoreBox}
      ProductItem={ProductItem}
      SkeletonCard={SkeletonCard}
      CoverPage={CoverPage}
      FloatingHelper={FloatingHelper}
      Pagination={Pagination}
      CategoryList={CategoryList}
      renderEmptyState={renderDefaultEmptyState}
      showCategoryList
      categoryListUseFloatingDropdown
    />
  );
}

export default StorePage;
